export class User {
  public _id: string
  public name: string;
  public email: string;
  public role: string;
  public password: string;
}



// WEBPACK FOOTER //
// ./src/app/models/user.model.ts